import { useEffect, useState } from "react";
import ifasBanner from "../../assets/img/ifas-banner.png";

/**
 * Обложка для новостей без собственной картинки — эмблема МФСА на фирменном
 * фоне. Выглядит оформленной, в отличие от серой плашки с иконкой.
 */
export const NEWS_PLACEHOLDER_IMAGE = ifasBanner;

/**
 * Подставляет заглушку, если картинки нет или она не загрузилась.
 *
 * Второй случай сейчас основной: бэкенд отдаёт пути вида
 * `/backend/uploads/...`, а сервер закрывает эту папку (403), поэтому без
 * фолбэка в карточках висели бы «битые» картинки.
 *
 * @param {string | null | undefined} image
 * @returns {{ src: string, onError: () => void, isPlaceholder: boolean }}
 */
export function useNewsImage(image) {
  const [failed, setFailed] = useState(false);

  // Сбрасываем флаг при переходе на другую новость.
  useEffect(() => setFailed(false), [image]);

  const isPlaceholder = !image || failed;

  return {
    src: isPlaceholder ? NEWS_PLACEHOLDER_IMAGE : image,
    onError: () => setFailed(true),
    isPlaceholder,
  };
}
